import { argAttribs } from "./args";
export const pclike = (ctor, args) => {
    const attr = argAttribs(args);
    return new ctor(args.length === 1 ? args[0] : args, attr);
};
